
export default {
  name: 'ComparisonItemCell',

  props: {
    data: {
      type: null,
      required: true
    }
  },

  data() {
    return {
      item: this.data
    };
  }

  // watch: {
  //   data(newVal) {
  //     this.item = newVal;
  //   }
  // }
};
